import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgMakeItAFavoriteCard',
})
export default class CmgMakeItAFavoriteCard extends Vue {
  @Prop({ required: true, type: Boolean })
  showFavorites!: boolean;

  get headerText(): string {
    return this.showFavorites ? 'Make it a favorite' : 'No recent orders';
  }

  get imageUrl() {
    return this.showFavorites ? this.$appStore.state.cms.images.icons.heartEmpty.default : '';
  }
}
